import React, { useEffect, useState } from 'react';
import { Bell, BellRing, BellOff } from 'lucide-react';
import { toast } from 'sonner';
import { pushSupported, getPermission, isSubscribed, subscribePush, unsubscribePush, sendTestPush } from '@/lib/push';

export default function PushToggle() {
  const [supported] = useState(pushSupported());
  const [subscribed, setSubscribed] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (supported) isSubscribed().then(setSubscribed);
  }, [supported]);

  const enable = async () => {
    setBusy(true);
    try {
      await subscribePush();
      setSubscribed(true);
      toast.success('Bildirimler açıldı');
      try { await sendTestPush(); } catch {}
    } catch (e) {
      toast.error(e.message || 'Bildirimler açılamadı');
    } finally { setBusy(false); }
  };

  const disable = async () => {
    setBusy(true);
    try {
      await unsubscribePush();
      setSubscribed(false);
      toast.success('Bildirimler kapatıldı');
    } catch {
      toast.error('İşlem başarısız');
    } finally { setBusy(false); }
  };

  const blocked = supported && getPermission() === 'denied';

  return (
    <div className="bg-cream2/60 border border-navy/10 rounded-lg p-4" data-testid="push-toggle">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <span className="w-9 h-9 rounded-full bg-gold/15 flex items-center justify-center">
            {subscribed ? <BellRing strokeWidth={1.25} className="w-4.5 h-4.5 text-gold" /> : <Bell strokeWidth={1.25} className="w-4.5 h-4.5 text-gold" />}
          </span>
          <div>
            <p className="text-sm font-medium text-navy">Anlık Bildirimler</p>
            <p className="text-xs text-navy/50">Kampanya ve hakediş güncellemeleri</p>
          </div>
        </div>
        {!supported ? (
          <span className="text-xs text-navy/40">Desteklenmiyor</span>
        ) : blocked ? (
          <span className="inline-flex items-center gap-1 text-xs text-redx"><BellOff strokeWidth={1.25} className="w-3.5 h-3.5" /> Engelli</span>
        ) : subscribed ? (
          <button onClick={disable} disabled={busy} data-testid="push-disable-btn" className="text-xs border border-navy/20 text-navy px-3 py-1.5 rounded-full active:scale-95 transition-transform disabled:opacity-50">
            Kapat
          </button>
        ) : (
          <button onClick={enable} disabled={busy} data-testid="push-enable-btn" className="text-xs bg-navy text-cream px-3 py-1.5 rounded-full active:scale-95 transition-transform disabled:opacity-50">
            {busy ? 'Açılıyor...' : 'Aç'}
          </button>
        )}
      </div>
      {blocked && (
        <p className="text-xs text-navy/50 mt-3">Tarayıcı ayarlarından bu site için bildirim iznini etkinleştirin.</p>
      )}
    </div>
  );
}
